import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../../common/theme-colors';
import theme from '../../../common/theme';

export const getStyles = (colors: ThemeColors, fallbackBackground: string) =>
  StyleSheet.create({
    rhs: {
      flex: 1,
      backgroundColor: colors.elevation0,
    },
    rhsFallback: {
      backgroundColor: fallbackBackground,
    },
    brandMark: {
      ...StyleSheet.absoluteFill,
      alignItems: 'center',
      justifyContent: 'center',
    },
    logo: {
      width: 200,
      height: 100,
    },
    attribution: {
      left: 0,
      right: 0,
      alignItems: 'center',
    },
    bubble: {
      paddingVertical: 14,
      paddingHorizontal: 20,
      borderWidth: 1,
      borderColor: colors.borderMuted,
      borderTopLeftRadius: theme.radius.l,
      borderTopRightRadius: theme.radius.l,
      borderBottomLeftRadius: theme.radius.l,
      backgroundColor: colors.elevation0,
      ...theme.shadow.light,
      position: 'absolute',
      top: 24,
      right: 24,
    },
    bubbleText: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.text,
      fontFamily: theme.fonts.regular,
    },
  });
